import React from 'react'
import styles from './CategoryTitle.module.css';

const CategoryTitle = ({title}) => {
  return (
    <h1 className={`${styles.title} text-2xl`}>{title}</h1>
  )
}

export default CategoryTitle